import axios from "axios";
import { BASE_URL } from "../../../Helper/Helper";
const ProjectState = {
  addProject: async (requestOptions) => {
    // FETCH API CALL For all notes
    const response = await axios.post(
      `${BASE_URL}/api/v2/admin/create-project`,
      requestOptions,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          token: localStorage.getItem("token"),
        },
      }
    );

    // console.log("response", response);
    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  getProject: async (params) => {
    // console.log("params", params);
    const response = await axios.get(`${BASE_URL}/api/v2/admin/get-project`, {
      params,
      headers: {
        token: localStorage.getItem("token"),
      },
    });

    // console.log("project-state-res---", response);
    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  getProjectById: async (id) => {
    const response = await axios.get(
      `${BASE_URL}/api/v2/admin/getbyid-project/${id}`,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    // console.log("response", response);
    let datas = response.data.data;
    // console.log("datas", datas);
    return datas;
  },

  deleteProject: async (id) => {
    const response = await axios.delete(
      `${BASE_URL}/api/v2/admin/delete-project/${id}`,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  updateProject: async (id, requestOptions) => {
    // FETCH API CALL For all notes
    const response = await axios.put(
      `${BASE_URL}/api/v2/admin/update-project/${id}`,
      requestOptions,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          token: localStorage.getItem("token"),
        },
      }
    );

    // console.log("res", response);
    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  updateProjectyById: async (id, updatedFiles) => {
    // FETCH API CALL For all files
    await axios.put(
      `${BASE_URL}/api/v2/admin/single-project/${id}`,
      updatedFiles,
      {
        headers: {
          "Content-Type": "application/json",
          token: localStorage.getItem("token"),
        },
      }
    );
  },

  updateProjectStatus: async (id, requestOptions) => {
    // FETCH API CALL For all notes
    const response = await axios.post(
      `${BASE_URL}/api/v2/admin/project-status/${id}`,
      requestOptions,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  updateProjectShareCount: async (id, requestOptions) => {
    const response = await axios.post(
      `${BASE_URL}/api/v2/admin/project-share/${id}`,
      requestOptions,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  updateProjectAvail: async (id, requestOptions) => {
    // FETCH API CALL For all notes
    const response = await axios.post(
      `${BASE_URL}/api/v2/admin/project-avail/${id}`,
      requestOptions,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },
};

export default ProjectState;
